// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","form":"EditBalanceForm_form__rv1O8","input":"EditBalanceForm_input__a15V0","buttonGroup":"EditBalanceForm_buttonGroup__14lMR"};